// 获取sessionStorage
export const getSessionStorage = key => {
    if (window.sessionStorage.getItem(key)) {
        return JSON.parse(window.sessionStorage.getItem(key))
    }
    return null
}
// 设置sessionStorage
export const setSessionStorage = (key, val) => {
    window.sessionStorage.setItem(key, JSON.stringify(val))
}

// 清除sessionStorage
export const clearSessionStorage = key => {
    window.sessionStorage.removeItem(key)
}


